import styled from 'styled-components';

export const MainContainer = styled.div`
    margin: 32px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Title = styled.span`
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #101828;
`;

export const SubTitle = styled.span`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #667085;
`;

export const EmptyIntegrationCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px;
`;


export const EmptyIntegrationCard = styled.div`
    border: 1px solid black;
    border-radius: 8px;
    padding: 8px;
`;
